import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * SEO组件 - 为每个页面提供元数据和社交媒体标签
 * @param {Object} props
 * @param {string} props.title - 页面标题
 * @param {string} props.description - 页面描述
 * @param {string} props.keywords - SEO关键词，逗号分隔
 * @param {string} props.canonicalUrl - 规范URL，默认为当前URL
 * @param {string} props.ogImage - 社交媒体分享图片URL
 * @param {string} props.ogType - Open Graph类型，默认为website
 * @param {string} props.twitterCard - Twitter卡片类型，默认为summary_large_image
 */
const SEO = ({
  title = 'SnapBeautify - Professional Online Image Beautification Tool',
  description = 'SnapBeautify is a professional online image beautification tool that supports adding beautiful backgrounds and annotations to screenshots with one click, making your images look more professional.',                                            
  keywords = 'image beautification,screenshot beautification,image editor,online image tool,image annotation,image cropping',
  canonicalUrl = typeof window !== 'undefined' ? window.location.href : 'https://snapbeautify.pixzens.com/',
  ogImage = 'https://snapbeautify.pixzens.com/og-image.png',
  ogType = 'website',
  twitterCard = 'summary_large_image',
}) => {
  // 基本URL
  const baseUrl = 'https://snapbeautify.pixzens.com';
  
  // 完整的图片URL
  const fullImageUrl = ogImage.startsWith('http') ? ogImage : `${baseUrl}${ogImage}`;
  
  // 完整的规范URL
  const fullCanonicalUrl = canonicalUrl.startsWith('http') ? canonicalUrl : `${baseUrl}${canonicalUrl}`;
  
  return (
    <Helmet>
      {/* 基本元数据 */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* 规范链接 */}
      <link rel="canonical" href={fullCanonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      
      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:url" content={fullCanonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
    </Helmet>
  );
};

export default SEO; 